import React, { lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ScenarioProvider } from './contexts/ScenarioContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { Layout } from './components/layout/Layout';
import { KonamiGate } from './components/layout/KonamiGate';
import { Census } from './pages/Census';
const MapPage = lazy(() => import('./pages/MapPage').then(m => ({
  default: m.MapPage
})));
const Countries = lazy(() => import('./pages/Countries').then(m => ({
  default: m.Countries
})));
const CountryDetail = lazy(() => import('./pages/CountryDetail').then(m => ({
  default: m.CountryDetail
})));
const Networks = lazy(() => import('./pages/Networks').then(m => ({
  default: m.Networks
})));
const Models = lazy(() => import('./pages/Models').then(m => ({
  default: m.Models
})));
const Platforms = lazy(() => import('./pages/Platforms').then(m => ({
  default: m.Platforms
})));
const Directories = lazy(() => import('./pages/Directories').then(m => ({
  default: m.Directories
})));
const Discovery = lazy(() => import('./pages/Discovery').then(m => ({
  default: m.Discovery
})));
const Methodology = lazy(() => import('./pages/Methodology').then(m => ({
  default: m.Methodology
})));
const Frontier = lazy(() => import('./pages/Frontier').then(m => ({
  default: m.Frontier
})));
const NotFound = lazy(() => import('./pages/NotFound').then(m => ({
  default: m.NotFound
})));
interface AppProps {
  defaultScenario?: 'verifiable' | 'device' | 'ambient';
  defaultTheme?: 'dark' | 'light' | 'color';
}
export function App({
  defaultScenario = 'device',
  defaultTheme = 'dark'
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="38o4fjf2g6l5t">
      <ThemeProvider initial={defaultTheme} data-id="element-1" data-mp="3dkl0k0ecojeo">
      <ScenarioProvider initial={defaultScenario} data-id="element-2" data-mp="3dmfqjt4hb1pm">
        <KonamiGate data-id="element-3" data-mp="nvstj3irmlvf" />
        <Routes data-id="element-4" data-mp="nwc582htoe10">
          <Route element={<Layout data-id="element-6" data-mp="nvas7sh8xhgn" />} data-id="element-5" data-mp="nuraocvicv35">
            <Route index element={<Census data-id="element-8" data-mp="su45bjsmf6ga" />} data-id="element-7" data-mp="nxx05t81tyze" />
            <Route path="map" element={<MapPage data-id="element-10" data-mp="sssrss9dikbz" />} data-id="element-9" data-mp="stkjhrzunxwz" />
            <Route path="countries" element={<Countries data-id="element-12" data-mp="35oxut5vn8u6" />} data-id="element-11" data-mp="36hx792iaw2a" />
            <Route path="countries/:code" element={<CountryDetail data-id="element-14" data-mp="3uct2jhejuizf" />} data-id="element-13" data-mp="34x2njg6zd4f" />
            <Route path="networks" element={<Networks data-id="element-16" data-mp="3ucjbrrlok7so" />} data-id="element-15" data-mp="3udkqq75thefo" />
            <Route path="models" element={<Models data-id="element-18" data-mp="d4xp3e9cy9cu" />} data-id="element-17" data-mp="d4nxjm8nzu51" />
            <Route path="platforms" element={<Platforms data-id="element-20" data-mp="d2bibguajxvo" />} data-id="element-19" data-mp="d3cwvvain2i5" />
            <Route path="directories" element={<Directories data-id="element-22" data-mp="86w4uq0743zs" />} data-id="element-21" data-mp="851kbcsu6dw8" />
            <Route path="discovery" element={<Discovery data-id="element-24" data-mp="3gkv17sr2xrdt" />} data-id="element-23" data-mp="83i1befspoqr" />
            <Route path="methodology" element={<Methodology data-id="element-26" data-mp="3gja7g5clach0" />} data-id="element-25" data-mp="3gm64lrgm4x4e" />
            {/* Unlisted: reachable only via Konami code, direct URL, or the footer "." */}
            <Route path="frontier-7sigma" element={<Frontier data-id="element-28" data-mp="3qc948ai8p9bp" />} data-id="element-27" data-mp="3qb7lrkyw9kjy" />
            <Route path="*" element={<NotFound data-id="element-30" data-mp="3lkhdnzz333lk" />} data-id="element-29" data-mp="3qcinlf8s4i8f" />
          </Route>
        </Routes>
      </ScenarioProvider>
      </ThemeProvider>
    </BrowserRouter>;
}